var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiSrMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-map",
    clipPath: "url(#clip0_404_14087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66666 15.9292C4.54805 15.9091 4.43073 15.8819 4.31533 15.8479L2.40266 15.2479C1.711 15.0447 1.10359 14.6233 0.671056 14.0466C0.238524 13.4699 0.00406372 12.7688 0.00266266 12.0479V3.99988C0.00335588 3.45191 0.139131 2.91256 0.397968 2.42958C0.656806 1.94659 1.03072 1.53487 1.48662 1.23085C1.94252 0.926826 2.46634 0.739888 3.01171 0.686579C3.55708 0.63327 4.10719 0.715234 4.61333 0.925217L4.66666 0.949884V15.9292ZM13.7867 0.777884L13.7727 0.773217L11.9627 0.173217C11.7579 0.106804 11.5471 0.060584 11.3333 0.0352173V14.8766L12.7027 15.2712C13.095 15.3667 13.504 15.3719 13.8986 15.2863C14.2932 15.2007 14.6633 15.0266 14.9808 14.7771C15.2984 14.5276 15.5551 14.2093 15.7316 13.8461C15.9082 13.4829 15.9999 13.0844 16 12.6806V3.91722C15.999 3.22978 15.7859 2.55939 15.3898 1.99755C14.9936 1.4357 14.4338 1.00977 13.7867 0.777884ZM10 0.126551C10 0.126551 6.10466 1.24188 6 1.25322V15.9199C6.06666 15.9059 10 14.8292 10 14.8292V0.126551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_14087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrMap);
export default __webpack_public_path__ + "static/media/fi-sr-map.f7f52837bfeca50e0e753afc5705e6b3.svg";
export { ForwardRef as ReactComponent };